import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import PageTitle from '../../components/pageTitle';
import { getLanguageFontWithFallback } from '../../utils/fontUtils';
import './index.css';
import './index.tablet.css';
import './index.mobile.css';

function TermsOfService() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language || 'zh';

  // 云朵背景图路径
  const cloudBgUrl = `${process.env.PUBLIC_URL}/image/云朵背景.jpg`;

  return (
    <div className="terms-of-service-container">
      <div 
        className="terms-of-service-cloud-bg"
        style={{
          backgroundImage: `url(${cloudBgUrl})`
        }}
      />
      <div className="terms-of-service-section-container">
        <PageTitle marginBottom="53px">
          <span style={{ fontFamily: getLanguageFontWithFallback(currentLang) }}>{t('footer.terms')}</span>
        </PageTitle>
        <div className="terms-of-service-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{t('termsOfService.content')}</ReactMarkdown>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;

